import { forwardRef } from 'react';
import DefaultCheckbox from '@mui/material/Checkbox';

import FieldGroup from '../field-group';
import { CheckboxBaseProps } from './types';
import { checkboxCx } from './styles';
import { cx } from '@emotion/css';

const CheckboxBase = forwardRef<HTMLDivElement, CheckboxBaseProps>(
  (props, ref) => {
    const {
      name,
      isInvalid,
      label,
      className,
      helperText,
      value,
      checkboxClassName,
      error,
      ...resProps
    } = props;

    return (
      <FieldGroup
        ref={ref}
        invalid={isInvalid}
        error={error}
        helperText={helperText}
        className={className}
        name={name}
      >
        <div className={cx(checkboxCx, 'checkbox-wrapper')}>
          <DefaultCheckbox
            {...resProps}
            className={checkboxClassName}
            value={value}
          />

          {label && (
            <div className='checkbox-label'>
              <span>{label}</span>
            </div>
          )}
        </div>
      </FieldGroup>
    );
  },
);

export default CheckboxBase;
